import React from "react";
import { NavLink } from "react-router-dom";
import defaultPic from "../../resource/profile_pic/depic.png";

const BlogCard = ({
  //props
  id,
  userId,
  profilePic,
  name,
  createdAt,
  title,
  description,
  blogImage
}) => {

  return (
    <>
      {/* <div className="blog-field card"> */}
      <div className="card blog-card">
        <div className="row g-0">
          {/* #1 */}
          <div className="col-md-6">
            <img
              src={blogImage}
              alt="blog-pic"
              className="card-img"
            />
          </div>
          {/* #2 */}
          <div className="col-md-6">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="d-flex align-items-center">
                  <img
                    src={
                      !(profilePic === undefined) ? `${profilePic}` : defaultPic
                    }
                    alt="pic"
                    className="rounded-circle img-size"
                  />
                  <NavLink to={`/profile/${userId}`} style={{color: "black", textTransform: "capitalize", textDecorationLine: "none", fontSize: "17px"}}>
                    <span className="mx-2 fw-medium">{name}</span>
                  </NavLink>
                </div>
                <h6 className="card-subtitle text-muted sub-text">
                  {createdAt}
                </h6>
              </div>

              <h5 className="card-title text-center mt-4">{title}</h5>
              <p className="card-text">{description}</p>
              <NavLink
                to={`../../articles/${id}`}
                className="btn btn-primary btn-sm"
              >
                Read More
              </NavLink>
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default BlogCard;
